import { Check, ChevronsUpDown, Building2 } from 'lucide-react';
import { toast } from 'sonner';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth';

export function TenantSwitcher() {
  const user = useAuth((s) => s.user);
  const switchTenant = useAuth((s) => s.switchTenant);
  if (!user) return null;
  const memberships = user.memberships;
  const active = memberships.find((m) => m.tenantId === user.tenantId);

  const canSwitch = user.canSwitchTenants || user.isSuperAdmin;
  if (!canSwitch || memberships.length <= 1) {
    return (
      <div className="flex items-center gap-2 rounded-md border border-border bg-card px-3 py-2 text-sm">
        <Building2 className="h-4 w-4 text-muted-foreground" />
        <span className="truncate">{active?.tenantName ?? 'No tenant'}</span>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <Building2 className="h-4 w-4" />
          <span className="truncate">{active?.tenantName ?? 'Select'}</span>
          <ChevronsUpDown className="h-4 w-4 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel>Switch dealership</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {memberships.map((m) => (
          <DropdownMenuItem
            key={m.tenantId}
            onSelect={async () => {
              if (m.tenantId === user.tenantId) return;
              try {
                await switchTenant(m.tenantId);
                toast.success(`Switched to ${m.tenantName}`);
              } catch {
                toast.error('Could not switch');
              }
            }}
            className="gap-2"
          >
            <span className="flex-1 truncate">{m.tenantName}</span>
            {m.tenantId === user.tenantId && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
